import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProvisionService } from 'src/app/account/services/provision.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { PasswordService } from 'src/app/auth/services/password.service';
import { ApiService } from 'src/app/core/api.service';
import { LoggerService } from 'src/app/core/logger.service';
import { ErrCode, User } from 'src/app/shared/models';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';

@Component({
  selector: 'app-dialog-email-change',
  templateUrl: './dialog-email-change.component.html',
  styleUrls: ['./dialog-email-change.component.scss']
})
export class DialogEmailChangeComponent implements OnInit {
  @Input() user: User;
  @Input() showEmailDialog: boolean;
  @Output() showEmailDialogChange = new EventEmitter<boolean>();
  public curPass: string;
  public errcode: ErrCode;
  public isValidPassword: boolean = false;
  public newEmail: string;
  public isActionButtonLoading: boolean = false;
  public invalidEmailError: string = '';
  public incorrectPassError: string = '';
  public disabledEmailField: boolean = false;
  public showVerificationPrompt: boolean = false;

  constructor(
    private api: ApiService,
    private auth: AuthService,
    private log: LoggerService,
    private passwordService: PasswordService,
    private snackbarService: SnackbarService,
    private provisionService: ProvisionService) { }

  ngOnInit() {
    this.newEmail = '';
    this.curPass = '';
    this.errcode = undefined;
  }

  verifyPassword = async () => {
    this.isActionButtonLoading = true;
    try {
      await this.passwordService.passwordValid(this.user.email, this.curPass);
      this.isValidPassword = true;
      this.errcode = undefined;
      this.log.info('Password is valid, continue');
    } catch (ex) {
      this.isActionButtonLoading = false;
      if (ex instanceof ErrCode) {
        this.errcode = ErrCode.fromException(ex);
        if (this.errcode.code == 8101) {
          this.incorrectPassError = 'Enter your password';
        }
      }
    } finally {
      this.isActionButtonLoading = false;
    }
  }


  requestEmailChange = async () => {
    if (this.newEmail === '') {
      return;
    }
    this.isActionButtonLoading = true;
    try {
      const hashPass = await this.auth.getHashedPassword(this.user.email, this.curPass);
      await this.api.execute('requestemailchange', {
        newEmail: this.newEmail.toLowerCase(),
        password: hashPass
      });
      this.showVerificationPrompt = true;
      this.errcode = undefined;
    } catch (ex) {
      this.isActionButtonLoading = false;
      const err = ErrCode.fromException(ex);
      this.log.e('Error trying to request an email change', err);
      if (err.code == 9429) {
        this.log.error('User is ratelimited for request email change');
        this.errcode = new ErrCode(8009, 'Rate-limited for sending too many email change requests');
        this.disabledEmailField = true;
      } else if (err instanceof ErrCode) {
        this.errcode = err;
        if (this.errcode.code == 8102) {
          this.invalidEmailError = 'Enter a valid email address';
        }
        if (!this.errcode.msg || this.errcode.msg === 'An unknown error occurred') {
          this.closeEmailDialog();
          this.snackbarService.showMessage("critical", "Couldn’t complete action. Try again.");
        }
      }
    } finally {
      this.isActionButtonLoading = false;
    }
  }

  onVerify = () => {
    this.closeEmailDialog();
    this.snackbarService.showMessage("success", "Verification email sent.");
  }

  getPassword = (password: string) => {
    this.curPass = password;
    this.incorrectPassError = '';
  }

  getEmailAddress = (email: string) => {
    const trimmedEmail = this.provisionService.sanitizeEmail(email);
    this.newEmail = trimmedEmail;
    !this.provisionService.validEmail(this.newEmail) ? this.invalidEmailError = 'Enter a valid email address' : this.invalidEmailError = '';
  }

  closeEmailDialog = () => {
    this.showEmailDialog = false;
    setTimeout(() => {
      this.showEmailDialogChange.next(false);
    });
  }
}
